import { formatLocaleDateTime } from '../../../config/appConfig';

export function outboxQueuedSuccessMessage(undoDelaySeconds: number): string {
  if (undoDelaySeconds > 0) {
    return `Message will send in ${undoDelaySeconds} seconds. Check Outbox to cancel.`;
  }
  return 'Message queued for sending.';
}

export function outboxScheduledSuccessMessage(scheduledSendAt: string): string {
  const when = new Date(scheduledSendAt);
  const label = Number.isNaN(when.getTime()) ? scheduledSendAt : formatLocaleDateTime(when);
  return `Message scheduled for ${label}. Check Outbox to cancel or review.`;
}
